import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { LogOut, Settings } from 'lucide-react'
import { logout } from '@/api/resources/auth'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useAuthStore } from '@/stores/auth-store'

export function Topbar(): React.ReactNode {
  const { user, clearAuth } = useAuthStore()
  const navigate = useNavigate()

  const logoutMutation = useMutation({
    mutationFn: async () => logout(),
    onSettled: () => {
      clearAuth()
      void navigate({ to: '/login' })
    },
  })

  const initials = user
    ? `${user.first_name?.charAt(0) ?? ''}${user.last_name?.charAt(0) ?? ''}` || '?'
    : '?'

  return (
    <header className="bg-background sticky top-0 z-10 flex h-16 shrink-0 items-center justify-between px-6 py-2">
      <SidebarTrigger className="-ml-1" />
      <DropdownMenu>
        <DropdownMenuTrigger className="flex cursor-pointer items-center gap-2.5 outline-none">
          {user && (
            <span className="bg-primary/10 text-primary hidden rounded px-1.5 py-0.5 text-xs font-normal tracking-widest uppercase md:inline">
              {user.first_name} {user.last_name}
            </span>
          )}
          <Avatar className="size-10">
            <AvatarFallback>{initials}</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56 rounded-xl border-none p-0">
          <DropdownMenuItem
            className="gap-4 px-5 py-2.5 text-xs font-semibold"
            onClick={() => void navigate({ to: '/account' })}
          >
            <Settings className="size-5" />
            Account Settings
          </DropdownMenuItem>
          <DropdownMenuItem
            className="gap-4 px-5 py-2.5 text-xs font-semibold"
            onClick={() => logoutMutation.mutate()}
          >
            <LogOut className="size-5" />
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  )
}
